import * as React from 'react';
import { SVGProps } from 'react';

const SvgDropdownMenuHorizontalOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-9-2a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDropdownMenuHorizontalOutlined;
